import i18n from '@/plugins/i18n'

export default {
  methods: {
    getDay (date) {
      const daysOfWeek = [
        i18n.t('Вс'),
        i18n.t('Пн'),
        i18n.t('Вт'),
        i18n.t('Ср'),
        i18n.t('Чт'),
        i18n.t('Пт'),
        i18n.t('Сб')
      ]
      let i = new Date(date).getDay()
      return daysOfWeek[i]
    },
    getMonthFormat (month) {
      const monthOfYear = [
        i18n.t('Январь'),
        i18n.t('Февраль'),
        i18n.t('Март'),
        i18n.t('Апрель'),
        i18n.t('Май'),
        i18n.t('Июнь'),
        i18n.t('Июль'),
        i18n.t('Август'),
        i18n.t('Сентябрь'),
        i18n.t('Октябрь'),
        i18n.t('Ноябрь'),
        i18n.t('Декабрь')
      ]
      let i = new Date(month).getMonth()
      return monthOfYear[i]
    },
    getHeaderDateFormat (month) {
      const monthOfYear = [
        i18n.t('Январь'),
        i18n.t('Февраль'),
        i18n.t('Март'),
        i18n.t('Апрель'),
        i18n.t('Май'),
        i18n.t('Июнь'),
        i18n.t('Июль'),
        i18n.t('Август'),
        i18n.t('Сентябрь'),
        i18n.t('Октябрь'),
        i18n.t('Ноябрь'),
        i18n.t('Декабрь')
      ]
      let i = new Date(month).getMonth()
      let year = new Date(month).getFullYear()
      return `${monthOfYear[i]} ${year}`
    }
  }
}
